/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Listen_Go_CleaningInputs */

const en_onboarding_listen_go_cleaning = /** @type {(inputs: Onboarding_Listen_Go_CleaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cleaning or organizing`)
};

const es_onboarding_listen_go_cleaning = /** @type {(inputs: Onboarding_Listen_Go_CleaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiando u organizando`)
};

/**
* | output |
* | --- |
* | "Cleaning or organizing" |
*
* @param {Onboarding_Listen_Go_CleaningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_listen_go_cleaning = /** @type {((inputs?: Onboarding_Listen_Go_CleaningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Listen_Go_CleaningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_listen_go_cleaning(inputs)
	return en_onboarding_listen_go_cleaning(inputs)
});